export const config = {
    auth: { 
        clientId: '5f17b2e9-c976-40f2-8181-8a852182a1b6',
        redirectUrl: 'http://localhost:3000',
        scopes: [
            'user:read'
        ],
        authority: 'https://login.microsoftonline.com/ea80952e-a476-42d4-aaf4-5457852b0f7e',
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false
      }
};
